var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{class:['modal-container', _vm.appear === 'center' ? 'modal-center' : ''],style:({
    display: _vm.isShow ? 'block' : 'none',
    zIndex: _vm.zindex,
})},[(_vm.shadow !== 'none')?_c('mars-view',{class:['shadow', _vm.shadowAnimation],nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onShadowTap.apply(null, arguments)}}}):_vm._e(),_c('mars-view',{class:['main-content', _vm.appear === 'center' ? 'center-box' : 'around-box', _vm.appearAnimation]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }